import { render, staticRenderFns } from "./info-popup.vue?vue&type=template&id=3665fe1d"
import script from "./info-popup.vue?vue&type=script&lang=js"
export * from "./info-popup.vue?vue&type=script&lang=js"
import style0 from "./info-popup.vue?vue&type=style&index=0&id=3665fe1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports